export function buildAppShellNavHandlersProps({ chat, handlers, projectActions }) {
  return {
    onHomeViewChange: chat.setHomeView,
    onPrimaryDoChat: handlers.handlePrimaryDoChat,
    onPrimaryDoVoice: handlers.handlePrimaryDoVoice,
    onPrimaryDoCode: handlers.handlePrimaryDoCode,
    onThreadSelect: handlers.handleSecondaryThreadSelect,
    onNewChat: handlers.handleSecondaryNewChat,
    onDocuments: handlers.handleSecondaryDocuments,
    onDoVoice: handlers.handleSecondaryDoVoice,
    onBuild: handlers.handleSecondaryBuild,
    onMyApps: handlers.handleSecondaryMyApps,
    onPulse: handlers.handleSecondaryPulse,
    onSchedules: handlers.handleSecondarySchedules,
    onTriggers: handlers.handleSecondaryTriggers,
    onSkills: handlers.handleSecondarySkills,
    onConnections: handlers.handleSecondaryConnections,
    onNavAction: handlers.handleSecondaryNavAction,
    onNewProject: projectActions.handleNewProject,
    onProjectSelect: projectActions.handleProjectSelect,
    onRenameProject: projectActions.handleRenameProject,
    onThreadMenuAction: chat.activePrimaryKey === 'home' ? chat.handleThreadMenuAction : undefined,
    onRenameThread: chat.activePrimaryKey === 'home' ? chat.handleRenameThread : undefined,
  }
}
